import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import { buttonVariants } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { rejectClassName } from '@/utils/acceptButton'

interface Props {
  open?: boolean
  onOpenChange?(open: boolean): void
  stateLabel: string
  hasUnsavedChanges?: boolean
  confirm: (sendEmail: boolean) => void
}

export const SendMailConfirmDialog = ({
  open,
  onOpenChange,
  stateLabel,
  hasUnsavedChanges,
  confirm,
}: Props) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Status ändern: {stateLabel}</AlertDialogTitle>
          <AlertDialogDescription>
            Soll der Kunde per E-Mail über die Statusänderung informiert werden?
          </AlertDialogDescription>
          {hasUnsavedChanges && (
            <p className="text-muted-foreground text-sm">
              Ungespeicherte Änderungen werden verworfen
            </p>
          )}
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className={rejectClassName}>Abbrechen</AlertDialogCancel>
          <AlertDialogAction
            className={cn(
              buttonVariants({ variant: 'secondary' }),
              // AlertDialogAction bakes in the default variant's white hover text; override it.
              'hover:text-secondary-foreground'
            )}
            onClick={() => confirm(false)}
          >
            Ohne E-Mail
          </AlertDialogAction>
          <AlertDialogAction onClick={() => confirm(true)}>Mit E-Mail</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
